import { authErrorString } from '../AuthErrors';
import { AuthChallenge } from './data/AuthChallenge';
import { HTTPFetchResponse, PrimaryTokenTableEntry } from './data/AuthTypes';
import { logConstants } from '../../utils/Constants';
import AuthUtils from '../AuthUtils';
import { Logger } from '../Logger';
import AuthMan from '../AuthMan';
import SecondaryTokenServiceBase from './SecondaryTokenServiceBase';
import { config } from '../AuthConfig';

export default class CloudSecondaryTokenService extends SecondaryTokenServiceBase {
	private static instance: CloudSecondaryTokenService;

	static getInstance(): CloudSecondaryTokenService {
		if (!CloudSecondaryTokenService.instance) {
			CloudSecondaryTokenService.instance = new CloudSecondaryTokenService();
		}
		return CloudSecondaryTokenService.instance;
	}

	private constructor() {
		super();
	}

	async makeSecondaryTokenRequest(
		authChallenge: AuthChallenge,
		referenceUri: string,
		id: string,
		transactionId: string,
		secondaryUrl: string,
		allowCredUi: boolean
	): Promise<HTTPFetchResponse> {
		const storeConfig = AuthMan.getInstance().getStoreConfiguration();
		if (storeConfig && storeConfig[referenceUri]) {
			const authDomainInChallengeTokenServiceUrl =
				AuthUtils.getInstance().getAuthDomainFromTokenServiceUrl(
					authChallenge.getLocations()
				);
			const authDomainInStoreConfigTokenServiceUrl =
				AuthUtils.getInstance().getAuthDomainFromTokenServiceUrl(
					storeConfig[referenceUri].tokenServiceURL
				);

			if (
				(storeConfig[referenceUri].authDomain &&
					authChallenge.getAuthDomain() != storeConfig[referenceUri].authDomain) ||
				authDomainInChallengeTokenServiceUrl != authDomainInStoreConfigTokenServiceUrl
			) {
				Logger.getInstance().write(
					logConstants.ERROR,
					id +
						': Possible mismatch authdomains in challenge ' +
						authChallenge.getAuthDomain() +
						' and storeconfig ' +
						storeConfig[referenceUri].authDomain
				);
				Logger.getInstance().write(
					logConstants.ERROR,
					id +
						': Possible mismatch of authdomain between location url ' +
						authChallenge.getLocations() +
						' and tokenServiceURL ' +
						storeConfig[referenceUri].tokenServiceURL
				);
				throw new Error(
					authErrorString.DSAUTH_TOKEN_REQUEST_RESPONSE_AUTHDOMAIN_MISMATCH
				);
			}
		}

		return await super.makeSecondaryTokenRequest(
			authChallenge,
			referenceUri,
			id,
			transactionId,
			secondaryUrl,
			allowCredUi
		);
	}

	protected async getCachedPrimaryToken(
		authChallenge: AuthChallenge,
		referenceUri: string,
		id: string
	): Promise<PrimaryTokenTableEntry> {
		return await this.tokenManager.getCachedPrimaryToken(
			authChallenge.getAuthDomain(),
			referenceUri,
			id
		);
	}

	protected getSecondaryTokenLifetime(): string {
		return config.secondaryTokenLifetime;
	}
}
